// TODO: move it into core (but how to make sure usecontext returns CrossPath's context ?)
import React from 'react';

import type CrossPathServer from '@/server/.generated/app';
import type { TRouterContext as TServerRouterRequestContext } from '@server/services/router/response';
import type { TRouterContext as TClientRouterRequestContext } from '@client/services/router/response';
import type CrossPathClient from '.';

// TO Fix: TClientRouterRequestContext is unable to get the right type of CrossPathClient["router"]
    //    (it gets ClientApplication instead of CrossPathClient)
type ClientRequestContext = TClientRouterRequestContext<CrossPathClient["Router"], CrossPathClient>;
type ServerRequestContext = TServerRouterRequestContext<CrossPathServer["Router"]>
type UniversalServices = ClientRequestContext | ServerRequestContext

// Non-universla services are flagged as potentially undefined
export type ClientContext = (
    UniversalServices 
    & 
    Partial<Omit<ClientRequestContext, keyof UniversalServices>>
    &
    {
        Router: CrossPathClient["Router"],
    }
)

export const ReactClientContext = React.createContext<ClientContext>({} as ClientContext);
export default (): ClientContext => React.useContext<ClientContext>(ReactClientContext);